module.exports = __webpack_public_path__ + "media/images/vector@2x-34389f835d06b2313eac1eae0ee19243.png";